var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',[_c('title-name')],1),_c('b-col',[_c('en-title')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }